import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import FullUploadProduct from './FullUploadProductComponent';

const mapStateToProps = (state, props) => ({
  config: state.config,
  parentLocation: state.newProduct.parentLocation,
  runtimeConfig: props.runtimeConfig,
});

const mapDispatchToProps = () => ({});

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(FullUploadProduct);
